import React from 'react'
import { parseTextWithColors } from '@/utils/colorDetection'
import { ColorChip } from '@/components/ui/color-chip'

interface ColorAwareTextProps {
  text: string
  className?: string
}

export function ColorAwareText({ text, className }: ColorAwareTextProps) {
  // First, split by inline code (single backticks)
  const parts = text.split(/(`[^`]+`)/g)
  
  return (
    <span className={className}>
      {parts.map((part, index) => {
        // Check if this part is inline code (starts and ends with backtick)
        if (part.startsWith('`') && part.endsWith('`')) {
          const codeContent = part.slice(1, -1) // Remove backticks
          const segments = parseTextWithColors(codeContent)
          
          // If code contains hex colors, show them with color chips
          if (segments.some(s => s.isColor)) {
            return (
              <span key={index} className="inline-flex items-center gap-1">
                {segments.map((segment, segIndex) => (
                  <React.Fragment key={segIndex}>
                    {segment.isColor && segment.hex ? (
                      <ColorChip hex={segment.hex} />
                    ) : (
                      <code className="bg-gray-100 dark:bg-gray-800 px-1 py-0.5 rounded text-xs font-mono">
                        {segment.text}
                      </code>
                    )}
                  </React.Fragment>
                ))}
              </span>
            )
          } else {
            // Regular inline code without colors
            return (
              <code key={index} className="bg-gray-100 dark:bg-gray-800 px-1 py-0.5 rounded text-xs font-mono">
                {codeContent}
              </code>
            )
          }
        } else {
          // Regular text - check for colors
          const segments = parseTextWithColors(part)
          return (
            <React.Fragment key={index}>
              {segments.map((segment, segIndex) => (
                <React.Fragment key={segIndex}>
                  {segment.isColor && segment.hex ? (
                    <ColorChip hex={segment.hex} />
                  ) : (
                    segment.text
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          )
        }
      })}
    </span>
  )
}